import { axiosInstance } from '@/utils/api'
import { IConversionFactor } from '@/utils/types/model/conversionFactor'

interface IConversionFactorResponse {
  totalRecords: number
  conversionFactors: IConversionFactor[]
}

export async function getConversionFactors(
  page: number,
  limit: number,
  itemCode?: string
): Promise<IConversionFactorResponse> {
  const params: Record<string, unknown> = {
    page,
    limit,
  }

  if (itemCode) {
    params.itemCode = itemCode
  }

  const response = await axiosInstance.get('/conversion-factors', { params })
  return response.data
}
